export default __webpack_public_path__ + "static/media/detail_big_16_4.33fc7fe6.jpg";